import { Component, OnInit } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { RuleInterface } from '@vendasta/automata';
import { CommonActionPanelComponent } from '../../../../common//common-action-panel-component.directive';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { ProjectTemplateSelectorComponent } from '../../project-template-selector/project-template-selector.component';

@Component({
  selector: 'automata-create-project-in-task-manager-for-order-panel',
  templateUrl: './create-project-in-task-manager-for-order-panel.component.html',
  styleUrls: ['./create-project-in-task-manager-for-order-panel.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    ProjectTemplateSelectorComponent,
  ],
})
export class CreateProjectInTaskManagerForOrderPanelComponent extends CommonActionPanelComponent implements OnInit {
  loading = true;

  form: UntypedFormGroup = new UntypedFormGroup({});
  initialTemplateId: string;
  initialTitle: string;

  ngOnInit() {
    super.ngOnInit();
    const jsonData = this.step ? JSON.parse(this.step.data) : {};
    this.initialTemplateId = jsonData.template_id;
    this.initialTitle = jsonData.title;
  }

  enableSaving(savingEnabled: boolean): void {
    this.savingEnabled = savingEnabled;
  }

  getData(): any {
    const jsonData = this.step ? JSON.parse(this.step.data) : {};
    jsonData.template_id =
      this.form.controls?.template?.value?.identity?.templateId ||
      this.form.controls?.template?.value?.identity?.taskId;
    jsonData.title = this.form.controls?.template?.value?.title;
    return jsonData;
  }

  getRules(): RuleInterface[] {
    return [];
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [this.form];
  }

  isFormValid(): boolean {
    return !this.form.invalid;
  }
}
